import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ViewComingSoonComponent} from './view-coming-soon.component';

const routes: Routes = [{path: '**', component: ViewComingSoonComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewComingSoonRoutingModule {}
